import { render, staticRenderFns } from "./pro-bill.vue?vue&type=template&id=099983fa&scoped=true"
import script from "./pro-bill.vue?vue&type=script&lang=js"
export * from "./pro-bill.vue?vue&type=script&lang=js"
import style0 from "./pro-bill.vue?vue&type=style&index=0&id=099983fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099983fa",
  null
  
)

export default component.exports